module.exports = ".table > thead:first-child > tr > th:first-child,\n.table > tbody > tr > td:first-child {\n  text-align: left;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/planning-and-optimization/report/report.component.css
// module id = ./src/app/components/planning-and-optimization/report/report.component.css
// module chunks = main